<div
    v-if="is_open"
    class="modal fade show d-block settings-modal-backdrop"
    role="dialog"
    aria-modal="true"
    aria-labelledby="settings-add-user-title"
    tabindex="-1"
    @click.self="$emit('close')"
    @keydown.esc="$emit('close')"
>
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
        <div class="modal-content settings-modal-card overflow-hidden rounded-4">
            <div class="modal-header settings-modal-header align-items-start gap-3 p-4">
                <div>
                    <span class="profile-section-eyebrow fw-bold text-uppercase">New access</span>
                    <h5 id="settings-add-user-title" class="modal-title text-white fw-bold mb-1 mt-2">Add User</h5>
                    <p class="text-white-50 text-xs mb-0">Create a new user and set their access level.</p>
                </div>

                <button type="button" class="settings-modal-close d-inline-flex align-items-center justify-content-center flex-shrink-0 rounded-3" @click="$emit('close')" aria-label="Close">
                    <i class="bi bi-x-lg"></i>
                </button>
            </div>

            <!-- Only the fields scroll; the footer stays pinned under them -->
            <form class="d-flex flex-column overflow-hidden" @submit.prevent="submit_form">
                <div class="modal-body p-4">
                <div v-if="form_error" class="alert alert-danger border-0 rounded-4" role="alert">
                    {{ form_error }}
                </div>

                <div class="row g-3">
                    <div class="col-md-6">
                        <label for="settings-add-user-first-name" class="form-label profile-form-label fw-bold">First name</label>
                        <input id="settings-add-user-first-name" v-model.trim="user_form.first_name" type="text" class="form-control form-control-sm profile-form-control" required>
                    </div>

                    <div class="col-md-6">
                        <label for="settings-add-user-last-name" class="form-label profile-form-label fw-bold">Last name</label>
                        <input id="settings-add-user-last-name" v-model.trim="user_form.last_name" type="text" class="form-control form-control-sm profile-form-control" required>
                    </div>

                    <div class="col-md-6">
                        <label for="settings-add-user-email" class="form-label profile-form-label fw-bold">Email</label>
                        <input id="settings-add-user-email" v-model.trim="user_form.email" type="email" class="form-control form-control-sm profile-form-control" required>
                    </div>

                    <div class="col-md-6">
                        <label for="settings-add-user-phone" class="form-label profile-form-label fw-bold">Phone</label>
                        <input id="settings-add-user-phone" v-model.trim="user_form.phone_number" type="tel" class="form-control form-control-sm profile-form-control">
                    </div>

                    <div class="col-md-6">
                        <label for="settings-add-user-role" class="form-label profile-form-label fw-bold">Role</label>
                        <select id="settings-add-user-role" v-model="user_form.role" class="form-select form-select-sm profile-form-control settings-role-select" :disabled="is_loading_roles">
                            <option v-if="is_loading_roles" value="">Loading roles...</option>
                            <option v-for="role in role_options" :key="role.id" :value="role">{{ role.name }}</option>
                        </select>
                    </div>
                </div>
                </div>

                <div class="modal-footer px-4 py-3 gap-2 border-top border-light border-opacity-10">
                    <button type="button" class="btn btn-sm py-2 text-xs profile-secondary-btn" @click="$emit('close')">
                        Cancel
                    </button>

                    <button
                        type="submit"
                        class="btn btn-sm py-2 text-xs btn-primary profile-primary-btn text-white"
                        :disabled="is_saving">
                        <span v-if="is_saving" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        <span>Add user</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
